<template>
  <v-dialog
    :value="value"
    max-width="420"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="text-subtitle-1">
        <v-icon
          color="warning"
          class="mr-2"
        >
          mdi-alert
        </v-icon>
        予約が入っています
      </v-card-title>

      <v-card-text>
        <p class="mb-3">
          この卓には以下の予約があります。テーブルを作成しますか？
        </p>
        <v-list dense>
          <v-list-item
            v-for="(conflict, idx) in conflicts"
            :key="idx"
            class="px-0"
          >
            <v-list-item-icon class="mr-2">
              <v-icon
                small
                :color="statusColor(conflict.status)"
              >
                mdi-calendar-clock
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-body-2">
                {{ formatConflict(conflict) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="$emit('cancel')"
        >
          やめる
        </v-btn>
        <v-btn
          color="warning"
          @click="$emit('confirm')"
        >
          作成する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReservationConflictDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    conflicts: {
      type: Array,
      default: () => [],
    },
    formatConflict: {
      type: Function,
      default: () => '',
    },
  },
  methods: {
    statusColor(status) {
      const colors = {
        tentative: 'grey',
        confirmed: 'primary',
        checked_in: 'success',
      }

      return colors[status] || 'grey'
    },
  },
}
</script>
